<template>
    <div>
        
        <!-- Filter Start -->
        <highlight-filter
            :getFilterOnStart="true"
            :is_customer_page="false"
            @filterChange="changeFilter"
        ></highlight-filter>
        <!-- Filter End -->

        <!-- Stats Start -->
        <div class="row mb-4">
            <div class="col-lg-6 col-md-6">
                <div class="innerBox mt-4">
                    <!-- {{$store.state.tooltip}} -->
                    <highlight-label-maker-stats
                        title="Total QR"
                        :description="tooltip.total_qr"
                        :value="data.stats ? data.stats.total_qr != null ? numberWithCommas(data.stats.total_qr) : 0 : 'Loading...'"
                        icon="fa-qrcode"
                    ></highlight-label-maker-stats>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="innerBox mt-4">
                    <highlight-label-maker-stats
                        title="Total Scan"
                        :description="tooltip.total_scan"
                        :value="data.stats ? data.stats.total_scan != null ? numberWithCommas(data.stats.total_scan) : 0 : 'Loading...'"
                        icon="fa-barcode-read"
                    ></highlight-label-maker-stats>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="innerBox mt-4">
                    <highlight-label-maker-stats
                        title="Total Active"
                        :description="tooltip.total_active"
                        :value="data.stats ? data.stats.active != null ? numberWithCommas(data.stats.active) : 0 : 'Loading...'"
                        icon="fa-badge-check"
                    ></highlight-label-maker-stats>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="innerBox mt-4">
                    <highlight-label-maker-stats
                        title="Total Fail"
                        :description="tooltip.total_fail"
                        :value="data.stats ? data.stats.failed != null ? numberWithCommas(data.stats.failed) : 0 : 'Loading...'"
                        icon="fa-times-hexagon"
                    ></highlight-label-maker-stats>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="innerBox mt-4">
                    <highlight-label-maker-stats
                        title="Total Inactive"
                        :description="tooltip.total_inactive"
                        :value="data.stats ? data.stats.total_inactive != null ? numberWithCommas(data.stats.total_inactive) : 0 : 'Loading...'"
                        icon="fa-exclamation-triangle"
                    ></highlight-label-maker-stats>
                </div>
            </div>
        </div>
        <!-- Stats End -->

        <!-- Scan vs Active QR Start -->
        <div class="col-md-13">
                <div class="innerBox chart">
                    <h5 class="elegant--sub-title">
                        Scan vs Active
                        <i
                            class="fas fa-info-circle"
                            :id="'ScanInfo'"
                        ></i>
                        <b-popover target="ScanInfo" triggers="hover" placement="top">
                          <template #title>Scan vs Active QR</template>
                            {{tooltip.scan_vs_active}}
                        </b-popover>
                    </h5>
                    <label-maker-q-r-scan-distribution
                        v-if='data.labelBarScan'
                        :data="data.labelBarScan"
                        :filter="filter"
                    ></label-maker-q-r-scan-distribution>
                    <div v-else class="text-center mt-5 mb-5">
                        <h2 class="pt-5 pb-5">Loading...</h2>
                    </div>
                </div>
            </div>
        <!-- Scan vs Active QR End -->

        <!-- Detailed by Bottle Maker Chart Start -->
        <div class="col-md-13 mt-4">
            <div class="innerBox chart">
                <h5 class="elegant--sub-title">
                    Detailed by Bottle Maker
                    <i
                        class="fas fa-info-circle"
                        :id="'BottleMakerInfo'"
                    ></i>
                    <b-popover target="BottleMakerInfo" triggers="hover" placement="top">
                        <template #title>Detailed by Bottle Maker</template>
                        {{tooltip.detailed_by_bottle_maker}}
                    </b-popover>
                </h5>
                <label-maker-detail-by-bottle-maker
                    v-if='data.labelMakerBottleMaker'
                    :data="data.labelMakerBottleMaker"
                    :filter="filter"
                ></label-maker-detail-by-bottle-maker>
                <div v-else class="text-center mt-5 mb-5">
                    <h2 class="pt-5 pb-5">Loading...</h2>
                </div>
            </div>
        </div>
        <!-- Detailed by Bottle Maker End -->

        <!-- Pie Chart Start -->
        <div class="col-md-13 mt-4">
                <div class="innerBox chart">
                    <h5 class="elegant--sub-title">
                        QR Active By Label Maker
                        <i
                            class="fas fa-info-circle"
                            :id="'LabelMakerInfo'"
                        ></i>
                        <b-popover target="LabelMakerInfo" triggers="hover" placement="top">
                          <template #title>QR Active By Label Maker</template>
                            {{tooltip.qr_active_by_label_maker}}
                        </b-popover>
                    </h5>
                    <label-maker-q-r-scan-detailed
                        v-if='data.labelPieScan'
                        :data="data.labelPieScan"
                        :filter="filter"
                    ></label-maker-q-r-scan-detailed>
                    <div v-else class="text-center mt-5 mb-5">
                        <h2 class="pt-5 pb-5">Loading...</h2>
                    </div>
                </div>
            </div>
        <!-- Pie Chart End -->
        
        <!-- Table Start -->
        <!-- <div class="innerBox mt-4">
            <div class="row">
                <div class="col-md-10">
                    <h5 class="elegant--sub-title">History Report</h5>
                </div>
                <div class="col-md-2">
                    <button class="btn btn-elegant-download">Download Excel <i class="fas fa-download"></i></button>
                </div>
            </div>
            <div class="mt-3">
                <vue-universal-table
                    api_url="/api/highlight/labelmaker-scan-history"
                    :filter="vue_universal_table.filter"
                    :fields="vue_universal_table.fields"
                    :update="vue_universal_table.update"
                    :process_data="vue_universal_table.process_data"

                    sort_order="DESC"
                    sort_by="scan_date"
                ></vue-universal-table>
            </div>
        </div> -->
        <!-- Table End -->

    </div>
</template>

<script>
    import qs from 'qs'
    import highlightFilter from '@/components/filter/highlightFilter'

    import highlightLabelMakerStats from './children/HighlightLabelMakerStats'
    import labelMakerQRScanDistribution from './children/LabelMakerQRScanDistribution'
    import labelMakerQRScanDetailed from './children/LabelMakerQRScanDetailed'
    import LabelMakerDetailByBottleMaker from './children/LabelMakerDetailByBottleMaker'

    export default {
        metaInfo : {
            title : 'Highlight - Label Maker'
        },
        data () {
            return {
                tooltip : this.$store.state.tooltip.highlight.label_maker,
                filter : {
                    labelmaker : null,
                },
                data : {
                    stats : null,
                    labelBarScan : null,
                    labelMakerBottleMaker : null,
                    labelPieScan: null,
                },
                options : {
                    labelMaker : this.$store.getters.getLabelMaker,
                },
                vue_universal_table : {
                    fields : [
                        {title:"Variant", variable:"product_name"},
                        {title:"Volume", variable:"volume"},
                        {title:"Serial Number", variable:"serial_number"},
                        {title:"Kode QR", variable:"qrcode"},
                        {title:"Status", variable:"status", style_condition : {
                            'Success' : 'color:green; font-weight: bold',
                            'Reject' : 'color:red; font-weight: bold',
                            'Double Scan' : 'color:orange; font-weight: bold'
                        }},
                        {title:"Label Maker", variable:"label_maker"},
                        {title:"Date", variable:"scan_date"},
                    ],
                    filter : {
                        labelmaker : null,
                    },
                    update : 0,
                    process_data : `
                        for (var i in data) data[i].volume = (parseInt(data[i].volume))/1000 + ' Lt'

                        for (var i in data) {
                            data[i].product_name = data[i].product_name ? data[i].product_name : '-'
                            data[i].volume = data[i].volume ? data[i].volume : '-'
                            data[i].serial_number = data[i].serial_number ? data[i].serial_number : '-'
                            data[i].qrcode = data[i].qrcode ? data[i].qrcode : '-'
                            data[i].status = data[i].status ? data[i].status : '-'
                            data[i].label_maker = data[i].label_maker ? data[i].label_maker : '-'
                            data[i].scan_date = data[i].scan_date ? data[i].scan_date : '-'
                        }
                    `
                }
            }
        },
        components : {
            highlightFilter,

            highlightLabelMakerStats,
            labelMakerQRScanDistribution,
            labelMakerQRScanDetailed,
            LabelMakerDetailByBottleMaker,
        },
        mounted () {
            this.fetchData();
        },
        watch : {
            'filter' : {
                deep : true,
                handler : 'fetchData',
            },
        },
        methods : {
            changeFilter (filter) {
                let newFilter = {};

                for (var i in filter) newFilter[i] = filter[i];

                this.filter = structuredClone(newFilter);
                this.vue_universal_table.filter = structuredClone(newFilter);

                //Delete unnecessary filter for the table
                delete this.vue_universal_table.filter.filter;
                // console.log('%cHighlightLabelMaker.vue line:262 filter', 'color: #007acc;', filter);
                this.fetchData();
                this.vue_universal_table.update++;
            },
            fetchData(){
                //Reset All Data to null
                for (var i in this.data) this.data[i] = null;

                //Remove filter from filter
                let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
                console.log('%cHighlightLabelMaker.vue line:274 filterlessFilter', 'color: #007acc;', filterlessFilter);
                delete filterlessFilter.filter;

                //Get Stats
                this.$http.get(`/api/highlight/labelmaker-scan-overview?${qs.stringify(filterlessFilter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.stats = resp.data.data;
                })
                .catch((err)=>{console.log(err)});

                //Get Scan vs Active QR
                this.$http.get(`/api/highlight/labelmaker-variant-overview?${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    let data = resp.data.data;
                    for (var i in data) {
                        for (var j in data[i]) {
                            data[i][j.replace(/ /g, "")] = data[i][j];
                        }
                    }
                    this.data.labelBarScan = data;
                })
                .catch((err)=>{console.log(err)});

                //Get Detailed by Bottle Maker Chart
                this.$http.get(`/api/highlight/labelmaker-bottlemaker-overview?${qs.stringify(filterlessFilter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.labelMakerBottleMaker = resp.data.data;
                })
                .catch((err)=>{console.log(err)});

                //Get Label maker QR Scan Detailed
                this.$http.get(`/api/highlight/labelmaker-company-overview?${qs.stringify(filterlessFilter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.labelPieScan = resp.data.data;
                })
                .catch((err)=>{console.log(err)});
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;

    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
    }
</style>